var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-stats"},[_c('tapered-rule'),_vm._t("default"),_c('tapered-rule')],2)}
var staticRenderFns = []

export { render, staticRenderFns }